function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import ResizeObserver from 'resize-observer-polyfill';
export default function withParentSize(BaseComponent) {
  var WrappedComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(WrappedComponent, _React$Component);

    function WrappedComponent(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.state = {
        parentWidth: null,
        parentHeight: null
      };
      _this.animationFrameID = null;
      _this.debouncedResize = debounce(_this.resize.bind(_assertThisInitialized(_this)), props.debounceTime).bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = WrappedComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.ro = new ResizeObserver(function (entries
      /** , observer */
      ) {
        entries.forEach(function (entry) {
          var _entry$contentRect = entry.contentRect,
              width = _entry$contentRect.width,
              height = _entry$contentRect.height;
          _this2.animationFrameID = window.requestAnimationFrame(function () {
            _this2.debouncedResize({
              width: width,
              height: height
            });
          });
        });
      });
      this.ro.observe(this.container);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      window.cancelAnimationFrame(this.animationFrameID);
      this.ro.disconnect();
    };

    _proto.resize = function resize(_ref) {
      var width = _ref.width,
          height = _ref.height;
      this.setState({
        parentWidth: width,
        parentHeight: height
      });
    };

    _proto.render = function render() {
      var _this3 = this;

      var _this$state = this.state,
          parentWidth = _this$state.parentWidth,
          parentHeight = _this$state.parentHeight;
      return React.createElement("div", {
        style: {
          width: '100%',
          height: '100%'
        },
        ref: function ref(_ref2) {
          _this3.container = _ref2;
        }
      }, parentWidth !== null && parentHeight !== null && React.createElement(BaseComponent, _extends({
        parentWidth: parentWidth,
        parentHeight: parentHeight
      }, this.props)));
    };

    return WrappedComponent;
  }(React.Component);

  WrappedComponent.propTypes = {
    debounceTime: PropTypes.number
  };
  WrappedComponent.defaultProps = {
    debounceTime: 300
  };
  return WrappedComponent;
}